import type { FC } from 'react';

import { Icon, Tooltip } from '@zen/DesignSystem';

import { RejectPopover } from '../RejectPopover/RejectPopover';

interface SuggestionPillProps {
  id: string;
  onAccept: (id: string) => void;
  onReject: (id: string, reason: string) => void;
  proposedValueText: string;
}

export const SuggestionPill: FC<SuggestionPillProps> = ({ id, proposedValueText, onAccept, onReject }) => {
  return (
    <Tooltip tooltipContent={proposedValueText}>
      <div className="bg-sunset-light rounded-4xl flex items-center px-2 gap-2 justify-between w-auto h-8 text-navy-dark mt-2">
        <div className="flex items-center gap-2">
          <Icon icon="zicon-sparkles-empty" />
          <span className="font-extrabold truncate max-w-40">{proposedValueText}</span> suggested
        </div>

        <div className="flex gap-1 items-center w-1/3 justify-end">
          <Icon onClick={() => onAccept(id)} className="text-navy-dark right-4 cursor-pointer" icon="zicon-tick" />
          <RejectPopover id={id} onReject={onReject} />
        </div>
      </div>
    </Tooltip>
  );
};
